import { OnInit, OnDestroy, AfterViewInit, Injector } from '@angular/core';
import { ControlValueAccessor, FormGroup, FormBuilder, NgControl, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { Subscription, BehaviorSubject } from 'rxjs';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { SelectInputIndraComponent } from '@ibe.components/common/inputs/select-input-indra/select-input-indra.component';
import { PAX_TYPE_ADULT_CODE, PAX_TYPE_CHILD_CODE, PAX_TYPE_INFANT_CODE, PAX_TYPE_YOUNG_ADULT_CODE } from '@ibe.config';
import { INDRALanguageMarketService } from '@ibe.services/language-market-indra.service';
import { INDRAPassengerTypeService } from '@ibe.services/passenger-type.indra.service';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
var moment = extendMoment(Moment);
var DateFormIndraComponent = /** @class */ (function () {
    function DateFormIndraComponent(fb, dateService, injector, languageMarketService, passengerTypeService) {
        var _this = this;
        this.fb = fb;
        this.dateService = dateService;
        this.injector = injector;
        this.languageMarketService = languageMarketService;
        this.passengerTypeService = passengerTypeService;
        this.form = this.fb.group({
            dateDay: [null],
            dateMonth: [null],
            dateYear: [null]
        });
        this.label = '';
        this.uniqueId = '';
        this.dateDayLabel = '';
        this.dateMonthLabel = '';
        this.dateYearLabel = '';
        this.errorDay = '';
        this.errorMonth = '';
        this.errorYear = '';
        this.onlyFuture = false;
        this.futureAndPast = false;
        this.onlyPast = false;
        this.paxType = '';
        this.departureDate = "";
        this._days = new BehaviorSubject(_.range(1, 32).map(function (day) { return ({
            value: day,
            text: _this.dateService.INDRA_addLeadingZero(day)
        }); }));
        this.months = this.dateService.getMonths().map(function (month) { return ({
            text: _this.dateService.INDRA_addLeadingZero(month),
            value: month
        }); });
        this.sub$ = new Subscription();
        this.propagateChange = function (v) { };
    }
    Object.defineProperty(DateFormIndraComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            this._value = val;
            var year = null;
            var month = null;
            var day = null;
            if (val) {
                var dateArray = val.split("-"); //year //month //day
                if (dateArray.length == 3) {
                    year = dateArray[0] !== '0' ? parseInt(dateArray[0]) : null;
                    month = dateArray[1] !== '00' ? parseInt(dateArray[1]) : null;
                    day = dateArray[2] !== '00' ? parseInt(dateArray[2]) : null;
                }
            }
            if (!_.isEmpty(this.value)) {
                this.form.patchValue({
                    dateDay: day,
                    dateMonth: month,
                    dateYear: year
                }, { emitEvent: false });
            }
            else {
                this.form.reset({ emitEvent: false });
            }
            /*
            if(this.uniqueId == 'dob'){
                let year = null;
                let month = null;
                let day = null;
                if(val){
                    let dateArray = val.split("-"); //year //month //day
                    if(dateArray.length == 3){
                        year = dateArray[0] !== '0' ? parseInt(dateArray[0]) : null;
                        month = dateArray[1] !== '00' ? parseInt(dateArray[1]): null;
                        day = dateArray[2] !== '00' ? parseInt(dateArray[2]): null;
                    }
                }
                if (!_.isEmpty(this.value)) {
                    this.form.patchValue({
                        dateDay: day,
                        dateMonth: month,
                        dateYear: year
                    }, {emitEvent: false});
                } else {
                    this.form.reset({emitEvent: false});
                }
            }
            else{
                if (!_.isEmpty(this.value)) {
                    const date = new Date(val);
                    this.form.patchValue({
                        dateDay: date.getDate(),
                        dateMonth: date.getMonth() + 1,
                        dateYear: date.getFullYear()
                    }, {emitEvent: false});
                } else {
                    this.form.reset({emitEvent: false});
                }
            }
            */
            this.propagateChange(this.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateFormIndraComponent.prototype, "disabled", {
        set: function (value) {
            this.setDisabledState(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateFormIndraComponent.prototype, "hasErrors", {
        get: function () {
            return !_.isNil(this.control) && !_.isNil(this.control.errors);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateFormIndraComponent.prototype, "hasClassErrorDay", {
        get: function () {
            return !_.isNil(this.control) && this.control.invalid && this.control.touched ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateFormIndraComponent.prototype, "hasClassErrorMonth", {
        get: function () {
            return !_.isNil(this.control) && this.control.invalid && this.control.touched ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateFormIndraComponent.prototype, "hasClassErrorYear", {
        get: function () {
            return !_.isNil(this.control) && this.control.invalid && this.control.touched ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateFormIndraComponent.prototype, "days", {
        get: function () {
            return this._days.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    DateFormIndraComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    DateFormIndraComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fillYears();
        this.sub$.add(this.form.get('dateDay').valueChanges.subscribe(function (value) {
            _this.updateDay(value);
        }));
        this.sub$.add(this.form.get('dateMonth').valueChanges.subscribe(function (value) {
            _this.updateMonth(value);
        }));
        this.sub$.add(this.form.get('dateYear').valueChanges.subscribe(function (value) {
            _this.updateYear(value);
        }));
    };
    DateFormIndraComponent.prototype.ngAfterViewInit = function () {
        var ngControl = this.injector.get(NgControl, null);
        if (!_.isNil(ngControl)) {
            this.control = ngControl.control;
            if (this.uniqueId == 'dob' && this.control.value) {
                //retain restriction on dates upon loading when date is selected
                if (this.control && this.control.value) {
                    if (!_.isEqual(this.value, this.control.value)) {
                        this.value = this.control.value;
                    }
                    return;
                }
                this.INDRA_fillDaysAndMonths(this.departureDate);
            }
        }
        else {
            throw new Error('DateFormIndraComponent: Component is missing form control binding');
        }
    };
    DateFormIndraComponent.prototype.fillYears = function () {
        var mapFn = function (year) { return ({
            text: '' + year,
            value: year
        }); };
        if (this.onlyFuture) {
            this.years = this.dateService.getArrayOfYearsFromNowPlus50Years().map(mapFn);
        }
        else if (this.onlyPast) {
            if (this.paxType && this.uniqueId == 'dob') {
                var isUKMarket = this.languageMarketService.isUnitedKingdomMarket;
                var passengerTypeRules = this.INDRA_getPaxTypeRules();
                if (passengerTypeRules) {
                    var currentYear = this.departureDate ? parseInt(moment(this.departureDate).format('YYYY')) : new Date().getFullYear();
                    var maxYear = void 0;
                    var minYear = void 0;
                    var maxAge = void 0;
                    var minAge = void 0;
                    switch (this.paxType) {
                        case PAX_TYPE_ADULT_CODE:
                            if (isUKMarket) {
                                maxYear = currentYear - +passengerTypeRules.MAX_YTH_AGE;
                            }
                            else {
                                maxYear = currentYear - +passengerTypeRules.MIN_ADT_AGE;
                            }
                            minYear = maxYear - 100;
                            maxAge = currentYear - minYear;
                            minAge = currentYear - maxYear;
                            break;
                        case PAX_TYPE_YOUNG_ADULT_CODE:
                            minYear = currentYear - +passengerTypeRules.MAX_YTH_AGE;
                            maxYear = currentYear - +passengerTypeRules.MIN_YTH_AGE;
                            minAge = passengerTypeRules.MIN_YTH_AGE;
                            maxAge = passengerTypeRules.MAX_YTH_AGE;
                            break;
                        case PAX_TYPE_CHILD_CODE:
                            minYear = currentYear - +passengerTypeRules.MAX_CHD_AGE;
                            maxYear = currentYear - +passengerTypeRules.MIN_CHD_AGE;
                            minAge = passengerTypeRules.MIN_CHD_AGE;
                            maxAge = passengerTypeRules.MAX_CHD_AGE;
                            break;
                        case PAX_TYPE_INFANT_CODE:
                            minYear = currentYear - +passengerTypeRules.MAX_INF_AGE;
                            maxYear = currentYear - +passengerTypeRules.MIN_INF_AGE;
                            minAge = passengerTypeRules.MIN_INF_AGE;
                            maxAge = passengerTypeRules.MAX_INF_AGE;
                            break;
                    }
                    if (maxYear && minYear) {
                        this.minYear = this.dateService.INDRA_subtract(this.departureDate, maxAge, 'years').format('YYYY-MM-DD');
                        this.maxYear = this.dateService.INDRA_subtract(this.departureDate, minAge, 'years').format('YYYY-MM-DD');
                        this.years = this.dateService.getArrayOfYears(minYear, maxYear + 1).map(mapFn);
                        ;
                    }
                }
            }
            else {
                this.years = this.dateService.getArrayOfYearsFromNowMinus100Years().map(mapFn);
            }
        }
        else if (this.futureAndPast) {
            this.years = this.dateService.getArrayOfYearsFromNowMinus100Years(false).concat(this.dateService.getArrayOfYearsFromNowPlus50Years()).map(mapFn);
        }
        else {
            throw new Error('DateFormIndraComponent: You need to specify one of the inputs [onlyFuture, onlyPast, futureAndPast] of type boolean true');
        }
        if (this.uniqueId == 'dob' && this.years && this.years.length > 0) { //dob descending order
            this.years.sort(function (a, b) { return parseFloat(b.value) - parseFloat(a.value); });
        }
    };
    DateFormIndraComponent.prototype.updateDay = function (value) {
        if (this.uniqueId == 'dob') {
            if (!_.isEmpty(this.value)) {
                var month = parseInt(this.form.get('dateMonth').value) ? parseInt(this.form.get('dateMonth').value) : 0;
                var year = parseInt(this.form.get('dateYear').value) ? parseInt(this.form.get('dateYear').value) : 0;
                var date = this.dateService.convertStringDate({ year: year, month: month, day: value ? value : 0 });
                this.writeValue(date, false);
            }
            else {
                this.checkAllValuesFilledAndUpdateDate();
            }
            this.INDRA_fillAvailableYears();
        }
        else {
            if (!_.isEmpty(this.value)) {
                /*
                const month = this.dateService.getMonth(this.value);
                const year = this.dateService.getYear(this.value);
                const date = this.dateService.convertStringDate({ year: year, month: month, day: value });
                */
                var month = parseInt(this.form.get('dateMonth').value) ? parseInt(this.form.get('dateMonth').value) : 0;
                var year = parseInt(this.form.get('dateYear').value) ? parseInt(this.form.get('dateYear').value) : 0;
                var date = this.dateService.convertStringDate({ year: year, month: month, day: value ? value : 0 });
                this.writeValue(date, false);
            }
            else {
                this.checkAllValuesFilledAndUpdateDate();
            }
        }
    };
    DateFormIndraComponent.prototype.updateMonth = function (value) {
        var _this = this;
        var monthSelected = parseInt(this.form.get('dateMonth').value) ? parseInt(this.form.get('dateMonth').value) : null;
        var yearSelected = parseInt(this.form.get('dateYear').value) ? parseInt(this.form.get('dateYear').value) : null;
        if (parseInt(value) == monthSelected && this.uniqueId == 'dob' &&
            (parseInt(moment(this.maxYear).format('YYYY')) == yearSelected ||
                parseInt(moment(this.minYear).format('YYYY')) == yearSelected)) {
            if (PAX_TYPE_ADULT_CODE == this.paxType && yearSelected == parseInt(moment(this.minYear).format('YYYY'))) {
                this.INDRA_fillDaysAndMonths(null, true);
            }
            else if ((yearSelected == parseInt(moment(this.maxYear).format('YYYY')) || yearSelected == parseInt(moment(this.minYear).format('YYYY')))) {
                this.INDRA_fillDaysAndMonths(null, true);
            }
            else {
                if (yearSelected == parseInt(moment(this.maxYear).format('YYYY'))) {
                    this.INDRA_fillDaysAndMonths(moment(this.maxYear).format('YYYY-MM-DD'), true);
                }
                else {
                    this.INDRA_fillDaysAndMonths(this.departureDate);
                }
            }
        }
        else if (this.uniqueId == 'dob') {
            if ((yearSelected == parseInt(moment(this.maxYear).format('YYYY')) || yearSelected == parseInt(moment(this.minYear).format('YYYY')))) {
                this.INDRA_fillDaysAndMonths(null, true);
            }
            else {
                this.INDRA_fillDaysAndMonths();
            }
        }
        if (this.uniqueId == 'dob') {
            if (!_.isEmpty(this.value)) {
                // let monthSelected = parseInt(this.form.get('dateMonth').value) ? parseInt(this.form.get('dateMonth').value) : null;
                // let yearSelected = parseInt(this.form.get('dateYear').value) ? parseInt(this.form.get('dateYear').value) : null;
                var year = parseInt(this.form.get('dateYear').value) ? parseInt(this.form.get('dateYear').value) : 0;
                var day = parseInt(this.form.get('dateDay').value) ? parseInt(this.form.get('dateDay').value) : 0;
                var date = this.dateService.convertStringDate({ year: year, month: value ? value : 0, day: day });
                if (value && parseInt(value) !== monthSelected) {
                    var daysOpt = this.dateService.getDaysByMonth(value, year).map(function (da) { return ({
                        text: _this.dateService.INDRA_addLeadingZero(da),
                        value: da
                    }); });
                    this._days.next(daysOpt);
                }
                this.writeValue(date, false);
            }
            else {
                this.checkAllValuesFilledAndUpdateDate();
            }
        }
        else {
            if (!_.isEmpty(this.value)) {
                /*
                const year = this.dateService.getYear(this.value);
                let day = this.dateService.INDRA_getDate(this.value);
                let date = this.dateService.convertStringDate({ year: year, month: value, day: day });
                */
                var year = parseInt(this.form.get('dateYear').value) ? parseInt(this.form.get('dateYear').value) : 0;
                var day_1 = parseInt(this.form.get('dateDay').value) ? parseInt(this.form.get('dateDay').value) : 0;
                var date = this.dateService.convertStringDate({ year: year, month: value ? value : 0, day: day_1 });
                if (value && (year !== 0 || value !== 2)) {
                    var yearForDayGeneration = (year === 0 && value !== 2) ? 2000 : year;
                    var daysOpt = this.dateService.getDaysByMonth(value, yearForDayGeneration).map(function (da) { return ({
                        text: _this.dateService.INDRA_addLeadingZero(da),
                        value: da
                    }); });
                    this._days.next(daysOpt);
                    // if currently selected day is not in the new days list of values
                    if (day_1 !== 0 && daysOpt.filter(function (d) { return d.value == day_1; }).length === 0) {
                        day_1 = 0;
                        date = this.dateService.convertStringDate({ year: year, month: value ? value : 0, day: day_1 });
                    }
                }
                this.writeValue(date, false);
            }
            else {
                this.checkAllValuesFilledAndUpdateDate();
            }
        }
    };
    DateFormIndraComponent.prototype.updateYear = function (value) {
        var _this = this;
        if ((parseInt(value) == parseInt(moment(this.maxYear).format('YYYY')) || parseInt(value) == parseInt(moment(this.minYear).format('YYYY'))) && this.uniqueId == 'dob') {
            if (PAX_TYPE_ADULT_CODE == this.paxType && parseInt(value) == parseInt(moment(this.minYear).format('YYYY'))) {
                this.INDRA_fillDaysAndMonths(null, true);
            }
            else if ((parseInt(value) == parseInt(moment(this.maxYear).format('YYYY')) || parseInt(value) == parseInt(moment(this.minYear).format('YYYY')))) {
                this.INDRA_fillDaysAndMonths(null, true);
            }
            else {
                if (parseInt(value) == parseInt(moment(this.maxYear).format('YYYY'))) {
                    this.INDRA_fillDaysAndMonths(moment(this.maxYear).format('YYYY-MM-DD'), true);
                }
                else {
                    this.INDRA_fillDaysAndMonths(this.departureDate);
                }
            }
        }
        else if (this.uniqueId == 'dob') {
            this.INDRA_fillDaysAndMonths();
            if ((parseInt(value) == parseInt(moment(this.maxYear).format('YYYY')) || parseInt(value) == parseInt(moment(this.minYear).format('YYYY')))) {
                this.INDRA_fillDaysAndMonths(null, true);
            }
            else {
                this.INDRA_fillDaysAndMonths();
            }
        }
        if (this.uniqueId == 'dob') {
            if (!_.isEmpty(this.value)) {
                var month = parseInt(this.form.get('dateMonth').value) ? parseInt(this.form.get('dateMonth').value) : 0;
                var day = parseInt(this.form.get('dateDay').value) ? parseInt(this.form.get('dateDay').value) : 0;
                var date = this.dateService.convertStringDate({ year: value ? value : 0, month: month, day: day });
                if (value && parseInt(value) !== parseInt(moment(this.maxYear).format('YYYY')) && parseInt(value) !== parseInt(moment(this.minYear).format('YYYY'))) {
                    var daysOpt = this.dateService.getDaysByMonth(month, value).map(function (da) { return ({
                        text: _this.dateService.INDRA_addLeadingZero(da),
                        value: da
                    }); });
                    this._days.next(daysOpt);
                }
                this.writeValue(date, false);
            }
            else {
                this.checkAllValuesFilledAndUpdateDate();
            }
        }
        else {
            if (!_.isEmpty(this.value)) {
                /*
                const month = this.dateService.getMonth(this.value);
                let day = this.dateService.INDRA_getDate(this.value);
                let date = this.dateService.convertStringDate({ year: value, month: month, day: day });
                */
                var month = parseInt(this.form.get('dateMonth').value) ? parseInt(this.form.get('dateMonth').value) : 0;
                var day_2 = parseInt(this.form.get('dateDay').value) ? parseInt(this.form.get('dateDay').value) : 0;
                var date = this.dateService.convertStringDate({ year: value ? value : 0, month: month, day: day_2 });
                if (value && month !== 0) {
                    var daysOpt = this.dateService.getDaysByMonth(month, value).map(function (da) { return ({
                        text: _this.dateService.INDRA_addLeadingZero(da),
                        value: da
                    }); });
                    this._days.next(daysOpt);
                    // if currently selected day is not in the new days list of values
                    if (day_2 !== 0 && daysOpt.filter(function (d) { return d.value == day_2; }).length === 0) {
                        day_2 = 0;
                        date = this.dateService.convertStringDate({ year: value ? value : 0, month: month, day: day_2 });
                    }
                }
                this.writeValue(date, false);
            }
            else {
                this.checkAllValuesFilledAndUpdateDate();
            }
        }
    };
    DateFormIndraComponent.prototype.checkAllValuesFilledAndUpdateDate = function () {
        var day = this.form.get('dateDay').value;
        var month = this.form.get('dateMonth').value;
        var year = this.form.get('dateYear').value;
        if (!_.isNil(day) && !_.isNil(month) && !_.isNil(year)) {
            var date = this.dateService.convertStringDate({ year: year, month: month, day: day });
            this.writeValue(date, false);
        }
    };
    DateFormIndraComponent.prototype.ngOnDestroy = function () {
        this.sub$.unsubscribe();
    };
    DateFormIndraComponent.prototype.writeValue = function (value, onLoad) {
        if (onLoad === void 0) { onLoad = true; }
        /*
        if(this.uniqueId == 'dob'){
            if(onLoad && this.control && this.control.value){
                
                let date = value.split("-");
                if (date.length === 3 && date[0] !== '0' && date[1] !== '00' && date[2] !== '00' && !_.isEqual(this.value, value) && !date.some(el => el == null)){
                    this.value = value;
                }
                    return;
            }
            if(!_.isEqual(this.value, value)){
                this.value = value;
            }
        } else{
            if(!_.isEqual(this.value, value)){
                this.value = value;
            }
        }
        */
        if (onLoad && this.control && this.control.value) {
            var date = value.split("-");
            if (date.length === 3 && date[0] !== '0' && date[1] !== '00' && date[2] !== '00' &&
                !_.isEqual(this.value, value) && !date.some(function (el) { return el == null; })) {
                this.value = value;
            }
            return;
        }
        if (value) {
            var dateParts = value.split('-');
            if (dateParts.length === 3) {
                var year = parseInt(dateParts[0]);
                var month = parseInt(dateParts[1]);
                var day = parseInt(dateParts[2]);
                var isValidDate = this.isValidDate(year, month, day);
                if (!isValidDate) {
                    this._value = null;
                    this.form.reset({ emitEvent: false });
                    if (this.control) {
                        this.control.setErrors({ invalidDate: true });
                    }
                    this.propagateChange(null);
                    return;
                }
            }
        }
        if (!_.isEqual(this.value, value)) {
            this.value = value;
        }
    };
    DateFormIndraComponent.prototype.isValidDate = function (year, month, day) {
        if (isNaN(year) || isNaN(month) || isNaN(day))
            return false;
        if (year < 1 || month < 1 || day < 1)
            return false;
        if (month > 12)
            return false;
        var date = new Date(year, month - 1, day);
        return (date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day);
    };
    DateFormIndraComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    // we don't need to peform any action here
    DateFormIndraComponent.prototype.registerOnTouched = function () { };
    DateFormIndraComponent.prototype.setDisabledState = function (isDisabled) {
        this.dateDayEl.setDisabledState(isDisabled);
        this.dateMonthEl.setDisabledState(isDisabled);
        this.dateYearEl.setDisabledState(isDisabled);
    };
    DateFormIndraComponent.prototype.INDRA_fillDaysAndMonths = function (departureDate, isMinYear) {
        var _this = this;
        if (departureDate === void 0) { departureDate = null; }
        if (isMinYear === void 0) { isMinYear = false; }
        // //months set based on
        var departureMonth = parseInt(moment(departureDate).format('MM'));
        var departureDay = parseInt(moment(departureDate).format('DD'));
        var monthArray = [];
        var dayArray = [];
        var yearSelected = parseInt(this.form.get('dateYear').value);
        var monthSelected = parseInt(this.form.get('dateMonth').value);
        var daySelected = parseInt(this.form.get('dateDay').value) ? parseInt(this.form.get('dateDay').value) : 0;
        var minDay = parseInt(moment(this.minYear).format('DD'));
        if (!departureDate && yearSelected && (yearSelected == parseInt(moment(this.maxYear).format('YYYY')) || yearSelected == parseInt(moment(this.minYear).format('YYYY')))) {
            if (this.paxType == PAX_TYPE_INFANT_CODE && yearSelected == parseInt(moment(this.maxYear).format('YYYY'))) {
                departureDate = moment().format('YYYY-MM-DD');
                isMinYear = false;
            }
            else {
                if (yearSelected == parseInt(moment(this.maxYear).format('YYYY'))) {
                    isMinYear = false;
                    departureDate = moment(this.maxYear).format('YYYY-MM-DD');
                }
                else if (yearSelected == parseInt(moment(this.minYear).format('YYYY'))) {
                    departureDate = moment(this.minYear).format('YYYY-MM-DD');
                }
            }
            departureMonth = parseInt(moment(departureDate).format('MM'));
            departureDay = parseInt(moment(departureDate).format('DD'));
            this.dateService.getMonths().forEach(function (month) {
                if (departureDate && departureMonth >= month && !isMinYear && PAX_TYPE_ADULT_CODE !== _this.paxType) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
                else if (departureDate && isMinYear && departureMonth <= month && daySelected < (minDay + 1)) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
                else if ((isMinYear && PAX_TYPE_ADULT_CODE == _this.paxType)) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
            });
            if (monthSelected && yearSelected && monthSelected == departureMonth && (yearSelected == parseInt(moment(this.maxYear).format('YYYY')) || yearSelected == parseInt(moment(this.minYear).format('YYYY')))) {
                this.dateService.getDaysByMonth(monthSelected, yearSelected).forEach(function (day) {
                    if (day <= departureDay && !isMinYear) {
                        dayArray.push({
                            text: _this.dateService.INDRA_addLeadingZero(day),
                            value: day
                        });
                    }
                    else if (isMinYear && day > departureDay) {
                        dayArray.push({
                            text: _this.dateService.INDRA_addLeadingZero(day),
                            value: day
                        });
                    }
                });
                if (dayArray.length > 0 && parseInt(this.form.get('dateDay').value) < parseInt(dayArray[0].value)) {
                    // this.form.controls['dateDay'].setValue(dayArray[0].value);
                    this.form.controls['dateDay'].setValue(null);
                    this.control.setValue(null);
                }
                this._days.next(dayArray);
            }
            else {
                this._days = new BehaviorSubject(_.range(1, 32).map(function (day) { return ({
                    value: day,
                    text: _this.dateService.INDRA_addLeadingZero(day)
                }); }));
            }
        }
        else {
            this.dateService.getMonths().forEach(function (month) {
                if (departureDate && departureMonth >= month) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
                else if (!departureDate) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
            });
            if (monthSelected && yearSelected && (yearSelected == parseInt(moment(this.maxYear).format('YYYY')) || yearSelected == parseInt(moment(this.minYear).format('YYYY'))) && monthSelected == departureMonth) {
                this.dateService.getDaysByMonth(monthSelected, yearSelected).forEach(function (day) {
                    if (day <= departureDay && isMinYear) {
                        dayArray.push({
                            text: _this.dateService.INDRA_addLeadingZero(day),
                            value: day
                        });
                    }
                    else if (!isMinYear && day > departureDay) {
                        dayArray.push({
                            text: _this.dateService.INDRA_addLeadingZero(day),
                            value: day
                        });
                    }
                });
                if (dayArray.length > 0 && parseInt(this.form.get('dateDay').value) < parseInt(dayArray[0].value)) {
                    // this.form.controls['dateDay'].setValue(dayArray[0].value);
                    this.form.controls['dateDay'].setValue(null);
                    this.control.setValue(null);
                }
                this._days.next(dayArray);
            }
            else {
                this._days = new BehaviorSubject(_.range(1, 32).map(function (day) { return ({
                    value: day,
                    text: _this.dateService.INDRA_addLeadingZero(day),
                }); }));
            }
        }
        if (monthArray.length > 0) {
            this.months = monthArray;
        }
        this.INDRA_fillAvailableYears();
    };
    DateFormIndraComponent.prototype.INDRA_fillAvailableYears = function () {
        var _this = this;
        var yearSelected = parseInt(this.form.get('dateYear').value) ? parseInt(this.form.get('dateYear').value) : null;
        var monthSelected = parseInt(this.form.get('dateMonth').value) ? parseInt(this.form.get('dateMonth').value) : null;
        var daySelected = parseInt(this.form.get('dateDay').value) ? parseInt(this.form.get('dateDay').value) : null;
        var maxYear = this.paxType == PAX_TYPE_INFANT_CODE ? parseInt(moment().format('YYYY')) : parseInt(moment(this.maxYear).format('YYYY'));
        var maxMonth = this.paxType == PAX_TYPE_INFANT_CODE ? parseInt(moment().format('MM')) : parseInt(moment(this.maxYear).format('MM'));
        var maxDay = this.paxType == PAX_TYPE_INFANT_CODE ? parseInt(moment().format('DD')) : parseInt(moment(this.maxYear).format('DD'));
        var minYear = parseInt(moment(this.minYear).format('YYYY'));
        var minMonth = parseInt(moment(this.minYear).format('MM'));
        var minDay = parseInt(moment(this.minYear).format('DD'));
        var mapFn = function (year) { return ({
            text: '' + year,
            value: year
        }); };
        if (monthSelected || daySelected) {
            if ((monthSelected && maxMonth <= monthSelected && maxDay < daySelected && daySelected !== null)
                && (monthSelected && minMonth >= monthSelected && minDay >= daySelected && daySelected !== null) && this.paxType !== PAX_TYPE_ADULT_CODE) {
                // both max and min years
                this.years = this.dateService.getArrayOfYears(minYear + 1, maxYear).map(mapFn);
            }
            else if ((minMonth > monthSelected && monthSelected !== null && this.paxType !== PAX_TYPE_ADULT_CODE) || (monthSelected && minMonth >= monthSelected && minDay >= daySelected && daySelected !== null) && this.paxType !== PAX_TYPE_ADULT_CODE) {
                this.years = this.dateService.getArrayOfYears(minYear + 1, maxYear + 1).map(mapFn);
            }
            else if ((maxMonth < monthSelected && monthSelected !== null) || (monthSelected && maxMonth <= monthSelected && maxDay < daySelected && daySelected !== null)) {
                this.years = this.dateService.getArrayOfYears(minYear, maxYear).map(mapFn);
            }
            else {
                this.years = this.dateService.getArrayOfYears(minYear, maxYear + 1).map(mapFn);
            }
        }
        else {
            this.years = this.dateService.getArrayOfYears(minYear, maxYear + 1).map(mapFn);
        }
        if (this.uniqueId == 'dob') { //dob descending order
            this.years.sort(function (a, b) { return parseFloat(b.value) - parseFloat(a.value); });
        }
        var monthArray = [];
        if (yearSelected && yearSelected == parseInt(moment(this.minYear).format('YYYY'))) {
            this.dateService.getMonths().forEach(function (month) {
                if ((minMonth < month || (minMonth == month && daySelected >= (minDay + 1))) && PAX_TYPE_ADULT_CODE !== _this.paxType) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
                else if (!daySelected && minMonth <= month && PAX_TYPE_ADULT_CODE !== _this.paxType) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
                else if ((PAX_TYPE_ADULT_CODE == _this.paxType)) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
            });
        }
        else if (yearSelected && yearSelected == parseInt(moment(this.maxYear).format('YYYY'))) {
            this.dateService.getMonths().forEach(function (month) {
                if (maxMonth > month || (maxMonth == month && daySelected <= minDay)) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
                else if (!daySelected && maxMonth >= month) {
                    monthArray.push({
                        text: _this.dateService.INDRA_addLeadingZero(month),
                        value: month
                    });
                }
            });
        }
        else {
            //show all months since  uear is not min/max
            this.dateService.getMonths().forEach(function (month) {
                monthArray.push({
                    text: _this.dateService.INDRA_addLeadingZero(month),
                    value: month
                });
            });
        }
        if (monthArray.length > 0) {
            this.months = monthArray;
        }
    };
    DateFormIndraComponent.prototype.INDRA_getPaxTypeRules = function () {
        var paxTypeRules;
        paxTypeRules = this.passengerTypeService.passengerTypeRules;
        if (!paxTypeRules) {
            paxTypeRules = {
                MAX_ADT_AGE: "999",
                MAX_CHD_AGE: "12",
                MAX_CHD_PER_ADT: "4",
                MAX_CHD_PER_ADT_INF: "1",
                MAX_INF_AGE: "2",
                MAX_INF_PER_ADT: "1",
                MAX_STD_AGE: "26",
                MAX_YTH_AGE: "16",
                MIN_ADT_AGE: "12",
                MIN_CHD_AGE: "2",
                MIN_INF_AGE: "0",
                MIN_STD_AGE: "12",
                MIN_YTH_AGE: "12",
                RSD_ADVANCED_HOURS: "72"
            };
        }
        return paxTypeRules;
    };
    return DateFormIndraComponent;
}());
export { DateFormIndraComponent };
